import { IconButton } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { themesSelector } from "theme/selector";

import ChecklistIcon from "@mui/icons-material/Checklist";
import PlaylistRemoveIcon from "@mui/icons-material/PlaylistRemove";

import { changeIsHiddenSidenav } from "theme/redux";

const HiddenButtonHeader = () => {
  const dispatch = useDispatch();

  const { isHiddenSidenav, isMiniWindow } = useSelector(themesSelector);

  const handleCloseMenu = () => {
    dispatch(changeIsHiddenSidenav(false));
  };

  const handleOpenMenu = () => {
    dispatch(changeIsHiddenSidenav(true));
  };
  return (
    isMiniWindow &&
    (isHiddenSidenav ? (
      <IconButton onClick={handleCloseMenu}>
        <ChecklistIcon />
      </IconButton>
    ) : (
      <IconButton onClick={handleOpenMenu}>
        <PlaylistRemoveIcon />
      </IconButton>
    ))
  );
};

export default HiddenButtonHeader;
